import React from 'react'
import PropTypes from 'prop-types'

import { Dots, Square } from 'Components/Blocks/_Legacy'
import HeadingTitle from 'Components/Blocks/_Legacy/Heading/HeadingTitle'
import { Motion, Wrapper } from 'Components/UI'
import { Button, Icon, Text } from 'Components/UI/_Legacy'

import { ctoHeroImage } from 'Assets/_Legacy/CtoPage'
import arrowRightShortGlyph from 'Assets/_Legacy/Svg/arrow-right-short.svg'

import { useAppContext } from 'Services/AppContext'

import Badge from './Badge'
import {
  Container,
  Content,
  ContentHolder,
  DotsContainer,
  ImageHolder,
  StyledImage,
} from './styles'

function Hero({ data }) {
  const { openSupportWidget } = useAppContext()

  return (
    <Container>
      <Square
        angle={-30}
        horizontalAlign={[-530, null]}
        size={600}
        verticalAlign={[null, -300]}
      />

      <ImageHolder mt={[9, 9, 0]}>
        <Square
          angle={15}
          display={['none', 'none', 'none', 'flex']}
          horizontalAlign={[[0, 0, 0, 60, 35], null]}
          size={[0, 0, 0, 500, 780]}
          verticalAlign={[[0, 0, 0, 450, 500], null]}
        />
        <StyledImage
          alt="A bearded man in glasses, a white shirt and a dark tie sitting in an office chair, holding an open folder and gesturing with a pen"
          src={ctoHeroImage?.src}
        />

        <Badge
          bottom={[160, '50%', '35%', '35%', '5%', '10%']}
          kind={Badge.kind.business}
          left={['50%', '50%', '35%', '35%', '-10%']}
          text={data?.heroBusinessAdvisory}
        />

        <Badge
          bottom={['5%', '5%', '15%', '5%', '35%', '40%']}
          kind={Badge.kind.technical}
          left={['15%', '15%', '-20%', '0%', '35%', '55%']}
          text={data?.heroTechnicalImplementation}
        />
      </ImageHolder>

      <Wrapper>
        <Content>
          <DotsContainer>
            <Dots
              columns={17}
              corners={[true, true, true, true]}
              margin={5}
              rows={18}
            />
          </DotsContainer>

          <Motion>
            <ContentHolder>
              <HeadingTitle
                as="h1"
                fontSize={[32, 32, 56]}
                horizontalAlign="left"
                titleText={{
                  first: { text: data?.heroTitleBold, bold: true },
                  second: { text: data?.heroTitleRegular, bold: false },
                }}
              />

              <Text
                deepBlue
                fontSize={[14, 14, 16, 20]}
                light
                maxWidth={['100%', '100%', 416, 520]}
                mb={40}
                mt={20}
              >
                {data?.heroDescription}
              </Text>

              <Button blueprint width={250} onClick={openSupportWidget}>
                {data?.heroDiscussLinkText}
                &nbsp;
                <Icon glyph={arrowRightShortGlyph} size={10} />
              </Button>
            </ContentHolder>
          </Motion>
        </Content>
      </Wrapper>
    </Container>
  )
}

Hero.defaultProps = {
  data: {},
}

Hero.propTypes = {
  data: PropTypes.object,
}

export default Hero
